// truncate.ts
/**
 * Tronque une chaîne de caractères à une longueur maximale.
 * Ajoute une ellipsis (…) si le texte a été tronqué.
 *
 * @param text Le texte à tronquer
 * @param maxLength La longueur maximale du texte
 * @returns Le texte tronqué avec ellipsis si besoin
 */
function truncate(text: string | undefined | null, maxLength: number): string {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
}
export default truncate;
